/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Selected_File_LabelInputs */



/**
* | output |
* | --- |
* | "Selected:" |
*
* @param {Audio_Description_Export_Selected_File_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_selected_file_label = /** @type {((inputs?: Audio_Description_Export_Selected_File_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Selected_File_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionné :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählt:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Selezionato:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбрано:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionado:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已选：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択済み:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecionado:")
	return /** @type {LocalizedString} */ ("Selected:")
});